import React from "react";
import { connect } from 'react-redux';
import Datetime from "react-datetime";
import moment from 'moment'



// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import CircularProgress from '@material-ui/core/CircularProgress';
import Add from "@material-ui/icons/AddBox";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";




// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import SweetAlert from "react-bootstrap-sweetalert";


// style for this view
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";

import { formatStatus } from "../../../utils/helpers";
import { registerProjectRequest, registerProjectReset  } from "../../../actions/project";




const initialState = {
  name: '',
  remarks: '',
  success: false,
  error: {},
};

class RegisterProject extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }



  componentDidUpdate() {
    if (this.props.projectData.registerProjectSuccess) {
      this.setState({...initialState, success: true});
      this.props.dispatch(registerProjectReset());
    }
  }
  

  handleTextChange(field, event) {
    const { value } = event.target;
    let { error } = this.state
    const newError = { ...error, [field]: false }

    this.setState({ [field]: value, error: newError });
  }


  

  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }

  reset(){
    this.props.dispatch(registerProjectReset())
  }

  validateJobCardForm() {
    
    let errorFlag = false;
    let newError = this.state.error;
    if (!this.state.name) {
      newError.name = true;
      errorFlag = true;
    }
    if (!this.state.remarks) {
      newError.remarks = true;
      errorFlag = true;
    }


    this.setState({ error: newError });
    return errorFlag;
  }

  createProject() {
    console.log("testing payload", this.validateJobCardForm())
    if (this.validateJobCardForm()) {
      return;
    }


    const payload = {
      name: this.state.name,
      remarks: this.state.remarks,
    }

    console.log("payload", payload);
    this.props.dispatch(registerProjectRequest(payload));

  }

  render() {
    const { classes } = this.props;

    let e = []
    if(this.props.projectData.registerProjectErrors){
    const apiErrors = this.props.projectData.registerProjectErrors 
    const apiErrors2 = this.props.projectData.registerProjectErrors.message || []
    const apiErrors3 = this.props.projectData.registerProjectErrors.error || []

      console.log(apiErrors);
      
      let i;
      let error;
      if(apiErrors2){
        e.push(apiErrors2)
      }
      if(apiErrors3.length>0){
        e.push(apiErrors3)
      }
      for (i = 0; i < apiErrors.length; i++) {
       console.log( apiErrors[i].constraints[0]);
        error = (apiErrors[i].constraints)
        e.push(Object.values(error) +';     ' )
      }
      console.log("api errors: ", e);
      
    }

    const successButtonStyle = {backgroundColor: "#4CAF50", /* Green */
      border: "none",
      color: "white",
      padding: "15px 32px",
      textAlign: "center",
      textDecoration: "none",
      display: "inline-block",
      fontSize: "16px"}

      const dangerButtonStyle = {backgroundColor: "red", /* Green */
      border: "none",
      color: "white",
      padding: "15px 32px",
      textAlign: "center",
      textDecoration: "none",
      display: "inline-block",
      fontSize: "16px"}

    return (
      <div>
        {this.state.success ? <SweetAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title="Project Created Successfully!"
          onConfirm={() => this.setState({success:false})}
          onCancel={() => this.setState({success:false})}
          confirmBtnStyle={successButtonStyle}
        >
          
        </SweetAlert>: ''}
        {this.props.projectData.registerProjectErrors ? <SweetAlert
          danger
          style={{ display: "block", marginTop: "-100px" }}
          title={this.props.projectData.registerProjectErrors.statusCode}
          onConfirm={() => this.props.dispatch(registerProjectReset())}
          onCancel={() => this.props.dispatch(registerProjectReset())}
          confirmBtnStyle={dangerButtonStyle}
        > 
          {
            this.props.projectData.registerProjectErrors ?
              e.map((item, index) => {
                return <p key={index}> {item}</p>
              }) : 'An unexpected error occured'}
        </SweetAlert>: ''}

        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardText color="info">
                  <h4>Project Info</h4>
                </CardText>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={6} md={6}>
                      <CustomInput
                        error={this.state.error.name}
                        labelText="Project Name  *"
                        id="name"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.name,
                          onChange: this.handleTextChange.bind(this, 'name'),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <CustomInput
                        error={this.state.error.remarks}
                        labelText="Project Remarks *"
                        id="remarks"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.remarks,
                          onChange: this.handleTextChange.bind(this, 'remarks'),
                        }}
                      />
                    </GridItem>
                    
                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>


          
          
        </GridContainer>
        <div style={{ textAlign: "center" }}>

          {
            this.props.projectData.registerProjectLoader ?
              (<CircularProgress />) :
              (
                <Button color="info" onClick={this.createProject.bind(this)}>
                  <Add />
                  Register Project
            </Button>
              )
          }
        </div>
      </div>
    );
  }
}

export default withStyles(extendedFormsStyle)(
  connect(state => ({
    projectData: state.projectState
  }))(RegisterProject)
);
